import React from "react";
import "./WhatWeDoSection.css";
import { FaShippingFast, FaWarehouse, FaMoneyCheckAlt, FaFileInvoice, FaChartLine, FaStore } from "react-icons/fa";
import warehouse from "../../assets/Images/img001.jpg";
import { NavLink } from "react-router-dom";


const WhatWeDoSection = () => {
  return (
    <div className="whatwedo-section">
      <div className="content-card">
        {/* Image Column */}
        <div className="image-column">
          <img
            src={warehouse}
            alt="Warehousing"
            className="feature-image"
          />
        </div>

        {/* Text Content */}
        <div className="text-column">
          <h2 className="title">We Power Your Global Expansion – End-to-End</h2>
          <p className="description">
            We help foreign businesses sell in India without setting up offices or figuring out complex logistics.
            With our infrastructure, you handle your products—we handle the rest.
          </p>

          <ul className="feature-list">
            <li className="feature-item"><FaShippingFast className="icon" /> Shipping & Returns</li>
            <li className="feature-item"><FaWarehouse className="icon" /> Warehousing</li>
            <li className="feature-item"><FaMoneyCheckAlt className="icon" /> Payments & Tax</li>
            <li className="feature-item"><FaFileInvoice className="icon" /> Documentation</li>
            <li className="feature-item"><FaChartLine className="icon" /> Marketplace Strategy</li>
            <li className="feature-item"><FaStore className="icon" /> Retail Distribution</li>
          </ul>

          <button className="btn-learn-more">
  <NavLink to="/LearnMore">
    Learn More
  </NavLink>
</button>
        </div>
      </div>
    </div>
  );
};

export default WhatWeDoSection;
